import styled from "styled-components";

export const StyledPdfApplication = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 1000px;
  height: 1420px;
  direction: rtl;
  text-align: right;

  .wrapper {
    position: relative;
    width: 1000px;
    height: 100%;
    font-family: var(--bllink-font-primary);
    font-size: 26px;
    font-weight: bold;
    background-color: #fff;
  }
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    img {
      width: 100%;
      height: auto;
    }
  }
  .pdf-data {
    position: absolute;
    margin: 0;
    padding: 0;
    font-size: 26px;
    
    &.address {
      min-width: 400px;
      top: calc(50% + 75px);
      right: 200px;
    }
    &.phone {
      top: calc(50% + 130px);
      right: 200px;
    }
    &.phone-in-table {
      top: calc(50% - 205px);
      left: 180px;
    }
    &.email {
      top: calc(50% + 130px);
      left: 150px;
    }
    &.bank-code {
      top: calc(50% - 285px);
      left: 98px;
      letter-spacing: 12px;
    }
    &.branch-code-right {
      top: calc(50% - 230px);
      right: 150px;
    }
    &.branch {
      top: calc(50% - 285px);
      left: 153px;
      letter-spacing: 11px;
    }
    &.account {
      top: calc(50% - 285px);
      left: 298px;
      letter-spacing: 6.5px;
    }
    &.check {
      top: calc(50% - 153px);
      right: 101px;
    }
    &.bank-name {
      min-width: 300px;
      top: calc(50% - 270px);
      right: 145px;
      font-size: 22px;
    }
    &.owner-id {
      min-width: 180px;
      top: calc(50% + 20px);
      left: 140px;
    }
    &.name {
      min-width: 380px;
      top: calc(50% + 20px);
      right: 200px;
    }
    &.date {
      bottom: 75px;
      right: 170px;
    }
    &.signature {
      left: 80px;
      bottom: 60px;
      width: 200px;
      height: auto;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
`;
